import service from './axios';

// 管理员登录
export const adminLogin = (data) => {
  return service({
    method: 'post',
    url: '/manage/login',
    data
  });
};

// 管理员退出
export const adminLogout = () => {
  return service({
    method: 'post',
    url: '/manage/logout',
  });
};

// 获取管理员信息
export const getAdminInfo = () => {
  return service({
    method: 'get',
    url: '/manage/me',
  });
};

// 更新密码
export const updatePassword = (data) => {
  return service({
    method: 'put',
    url: '/manage/update-password',
    data
  });
};

// 获取仪表盘数据
export const getDashboardData = (days = 7) => {
  return service({
    method: 'get',
    url: '/manage/dashboard',
    params: {
      days: days
    }
  });
};